import { action } from 'typesafe-actions';

const entity = 'modal_search';
const UPDATE = `${entity}/UPDATE`;
const GET_NEXT_PAGE = `${entity}/GET_NEXT_PAGE`;
const UPDATE_PARAMS = `${entity}/UPDATE_PARAMS`;

const actionUpdateModal = (args: any) =>
  action(UPDATE, args);

const actionTickersNextPageModal = (args: any) =>
  action(GET_NEXT_PAGE, args);

const actionUpdateModalParams = (args: any) =>
  action(UPDATE_PARAMS, args);

export {
  UPDATE,
  GET_NEXT_PAGE,
  UPDATE_PARAMS,
  actionUpdateModal,
  actionUpdateModalParams,
  actionTickersNextPageModal,
};
